<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
               <div class="flex xs12 sm2">
                <v-select
                  :items="[{
                            text: '이름',
                            value: 'userName'
                          },
                          {
                            text: '승객회원 고유번호',
                            value: 'userId'
                          },
                          {
                            text: '결제 고유번호',
                            value: 'id'
                          },
                          {
                            text: '결제상태',
                            value: 'state'
                          }]"
                  name="header"
                  v-model="searchFormModel.filter"
                  label="header"
                ></v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'state'">
                <v-select
                        :items="state"
                        label="선택"
                        item-text="text"
                        item-value="state"
                        single-line
                        v-model="searchFormModel.filterText"
                >
                </v-select>
              </div>

              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="searchFormModel.filterText"
                hide-details
                class="hidden-sm-and-down"
                @keyup.enter="searchFilter"
                v-show="searchFormModel.filter !== 'state'"
              ></v-text-field>

              <v-btn icon @click="searchFilter">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="id"
                must-sort
                :total-items="totalItems"
                :loading="loading"
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">           
                  <td class="text-sm-center"><a @click="openBillingHistoryDialog(props.item.id)">{{ props.item.id }}</a></td>
                  <td class="text-sm-center"><a @click="openPassengerDetail(props.item.userId)">{{ props.item.userId }}</a></td>
                  <td class="text-sm-center">{{ props.item.userName }}</td>
                  <td class="text-sm-center">{{ changeDateText(props.item.regDate) }}</td>
                  <td class="text-sm-center">{{ props.item.amount }}</td>
                  <td class="text-sm-center">{{ props.item.cardName }}</td>
                  <td class="text-sm-center">{{ props.item.itemName }}</td>
                  <td class="text-sm-center">{{ changePaymentStateText(props.item.state) }}</td>
                  <td class="text-sm-center">
                    <v-btn color="primary" slot="activator" @click="cancelOrder(props.item.id)" :disabled="chkAvailableCancle (props.item.state)">환불</v-btn>
                  </td>
                </template>
              </v-data-table>
              <v-dialog v-model="billingHistory.dialog" max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">결제 이력 조회</span>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="결제이력고유번호"
                            v-model="detailBillingHistory.id"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field 
                            label="승객 고유번호"
                            v-model="detailBillingHistory.userId"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field 
                            v-model="detailBillingHistory.userName"
                            label="승객이름"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="카드 승인번호"
                            v-model="detailBillingHistory.cardAuthNo"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="카드이름"
                            v-model="detailBillingHistory.cardName"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="결제금액"
                            v-model="detailBillingHistory.amount"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <v-text-field
                            label="트랜잭션 번호"
                            v-model="detailBillingHistory.transactionId"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="결제 상태"
                            v-model="detailBillingHistory.state"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="결제일시"
                            v-model="detailBillingHistory.regDate"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4>
                          <v-text-field
                            label="취소일시"
                            v-model="detailBillingHistory.canceledDate"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4>
                          <v-text-field
                            label="결제실패일시"
                            v-model="detailBillingHistory.failedDate"
                            disabled></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer>
                    </v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="billingHistory.dialog = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/paymentState';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'userName',
        filterText: ''
      },
      totalItems: 0,
      loading: true,
      complex: {
        headers: [
          {
            text: '결제 번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '승객 회원 고유번호',
            value: 'userId',
            align: 'center'
          },
          {
            text: '이름',
            value: 'userName',
            align: 'center'
          },
          {
            text: '결제 일시',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '결제 금액',
            value: 'amount',
            align: 'center'
          },
          {
            text: '결제 수단',
            value: 'cardName',
            align: 'center'
          },
          {
            text: '결제 종류',
            value: 'itemName',
            align: 'center'
          },
          {
            text: '결제 상태',
            value: 'state',
            align: 'center'
          },
          {
            text: '환불',
            value: 'refund',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      billingHistory: {
        dialog: false
      },
      state: State,
      detailBillingHistory: {
        id: 1,
        userId: 1,
        userName: 1,
        amount: 1,
        cardName: 1,
        cardAuthNo: 1,
        transactionId: 1,
        state: 1,
        regDate: 1,
        canceledDate: 1,
        failedDate: 1
      }
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'BillingHistoryPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    },
    'searchFormModel.filter' () {
        this.searchFormModel.filterText = '';
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'billingHistories',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };

      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          if (data.statusCode != null && data.statusCode != '200'){
            throw data.message;
          }

          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          this.loading = false;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changePaymentStateText (stateCode) {
      if (stateCode != null) {
        for (let i = 0; i < this.state.length; i++) {
          if (this.state[i].state === stateCode) {
            return this.state[i].text;
          }
        }
      } else {
        return '-';
      }
    },
    changeDateText (date) {
      if (date != null) {
        let tmpDate = new Date(date);
        return tmpDate.toLocaleDateString().substr(0, 12).replace(' ', '').replace(' ', '') + ' '
              + tmpDate.toLocaleTimeString();
      } else {
        return '-';
      }
    },
    cancelOrder (id) {
      if (confirm('정말 환불처리 하시겠습니까?')) {
        const prameters = {
          method: 'cancelOrder',
          id: id
        };
        this.$store.dispatch('banbanAPI', prameters)
          .then(({ data }) => {
            if (data.status === 'OK') {
              alert('환불되었습니다.');
              this.banbanCreated();
            }
            else {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
            }
            top.getApp.progress.dialog = false;
          })
          .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      }
    },
    chkAvailableCancle (state) {
      if (state === 'SUCCESS') {
        return false;
      }
      else {
        return true;
      }
    },
    openPassengerDetail (id) {
      top.getApp.addPrevData('BillingHistoryPage', this.pagination, this.searchFormModel);
      this.$router.push('/member/passengerMemberDetail/' + id);
    },
    openBillingHistoryDialog(billingHistoryId) {
      if(billingHistoryId != '0') {
        const prameters = {
          method: 'searchBillingHistoryDetail',
          'id': billingHistoryId
        };
        this.$store.dispatch('banbanAPI', prameters)
          .then(({ data }) => {
            this.detailBillingHistory.id = data.id;
            this.detailBillingHistory.userId = data.userId != null ? data.userId : '-';
            this.detailBillingHistory.userName = data.userName != null ? data.userName : '-';
            this.detailBillingHistory.amount = data.amount != null ? data.amount : '-';
            this.detailBillingHistory.cardName = data.cardName != null ? data.cardName : '-';
            this.detailBillingHistory.cardAuthNo = data.cardAuthNo != null ? data.cardAuthNo : '-';
            this.detailBillingHistory.transactionId = data.transactionId != null ? data.transactionId : '-';
            this.detailBillingHistory.state = this.changePaymentStateText(data.state);
            this.detailBillingHistory.regDate = data.regDate != null ? data.regDate : '-';
            this.detailBillingHistory.canceledDate = data.canceledDate != null ? data.canceledDate : '-';
            this.detailBillingHistory.failedDate = data.failedDate != null ? data.failedDate : '-';
            this.billingHistory.dialog = true;
            for (let i = this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled').length - 1; i >= 0; i--) {
              this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled')[i].className = 'v-input v-text-field v-input--is-label-active v-input--is-dirty';
            }
            top.getApp.progress.dialog = false;
          })
          .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      }
    },
    searchFilter () {
      this.banbanCreated();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/payment/PassengerPayment.vue